import { AVATAR_TEMPLATE_SIZE } from '../consts';

const makePhotoSquare = (image: string): string =>
  `${image}?template=${AVATAR_TEMPLATE_SIZE}`;

export default makePhotoSquare;
